export type ConsentValue = 'granted' | 'denied'

const STORAGE_KEY = 'judahs_cookie_consent'
const EVENT_NAME = 'judahs-cookie-consent-change'

/**
 * 분석 쿠키(Google Analytics) 동의 상태를 보관한다.
 * 동의 전에는 GA 를 초기화하지 않는다 — RouteChangeTracker 참조.
 */
export const CookieConsent = {
	get: (): ConsentValue | null => {
		try {
			const stored = window.localStorage.getItem(STORAGE_KEY)
			return stored === 'granted' || stored === 'denied' ? stored : null
		} catch {
			// 프라이빗 모드 등 localStorage 접근 불가
			return null
		}
	},

	isGranted: (): boolean => CookieConsent.get() === 'granted',

	set: (value: ConsentValue): void => {
		try {
			window.localStorage.setItem(STORAGE_KEY, value)
		} catch {
			// 저장에 실패해도 이번 세션 동안은 아래 이벤트로 반영된다
		}
		window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: value }))
	},

	/** 선택을 지워 배너를 다시 띄운다 (푸터의 Cookie Settings). */
	reset: (): void => {
		try {
			window.localStorage.removeItem(STORAGE_KEY)
		} catch {
			// 무시 — 아래 이벤트로 이번 세션에는 반영된다
		}
		window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: null }))
	},

	/** 동의 상태가 바뀌면 호출된다. 해제 함수를 반환한다. */
	subscribe: (listener: (value: ConsentValue | null) => void): (() => void) => {
		const handler = () => listener(CookieConsent.get())

		window.addEventListener(EVENT_NAME, handler)
		// 다른 탭에서 바꾼 경우
		window.addEventListener('storage', handler)

		return () => {
			window.removeEventListener(EVENT_NAME, handler)
			window.removeEventListener('storage', handler)
		}
	},
}
